import { useEffect, useRef, useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';
import { useFocusEffect } from '@react-navigation/core';
import { useDispatch, useSelector } from 'react-redux';
import { resumeAfterPackingCam } from '../../../actions/scanpackScanningActions';
import { clearImageStates } from '../../../actions/orderActions';

const usePackingCamNavigation = (cameraRef) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const hasNavigated = useRef(false);

  const postScanPipeline = useSelector(state => state.scanPackScanning.postScanPipeline);
  const currentOrder = useSelector(state => state.scanPackScanning.currentOrder);
  const bothSettings = useSelector(state => state.user.bothSettings);
  const userInfo = useSelector(state => state.user.userInfo);
  const orderDetail = useSelector(state => state.order.order);
  const searchOrder = useSelector(state => state.scanpack?.searchOrder);

  const scanPackSettings = bothSettings?.data?.data?.scanpack_setting;

  useEffect(() => {
    if (postScanPipeline.currentStep === 'PackingCam' && postScanPipeline.active && !hasNavigated.current) {
      hasNavigated.current = true;
      dispatch(clearImageStates());
      navigation.navigate('PackingCam', {
        cameraInstance: cameraRef?.current || null,
        cameraOption: scanPackSettings?.capture_image_option,
        order: currentOrder,
        postScanning: scanPackSettings?.post_scanning_option,
        post_scanning_option_second: scanPackSettings?.post_scanning_option_second,
        returnToScanpackScanning: true,
        userRole: userInfo?.role || null,
        settingCheck: {
          callOrder: searchOrder,
          Order: orderDetail,
          bothSettings: bothSettings
        }
      });
    }

    if (postScanPipeline.currentStep !== 'PackingCam') {
      hasNavigated.current = false;
    }
  }, [postScanPipeline.currentStep, postScanPipeline.active]);

  useFocusEffect(
    useCallback(() => {
      if (hasNavigated.current && postScanPipeline.currentStep === 'PackingCam') {
        hasNavigated.current = false;
        dispatch(resumeAfterPackingCam());
      }
    }, [postScanPipeline.currentStep, dispatch])
  );
};

export default usePackingCamNavigation;
